"use strict";
exports.__esModule = true;
var ChartHeader_1 = require("./ChartHeader");
var ChartDataStructure_1 = require("./ChartDataStructure");
var ChartBreakdown_1 = require("./ChartBreakdown");
var Organization_1 = require("./Organization");
var ChartDataTable_1 = require("./ChartDataTable");
var Chart = /** @class */ (function () {
    function Chart(_a) {
        var id = _a.id, type = _a.type, name = _a.name, header = _a.header, structure = _a.structure, breakdowns = _a.breakdowns, frequencies = _a.frequencies, organization = _a.organization, table = _a.table, sql = _a.sql, label = _a.label, columns = _a.columns, columnType = _a.columnType;
        var _this = this;
        this.toJSON = function () { return ({
            id: _this.id,
            type: _this.type,
            name: _this.name,
            header: _this.header,
            structure: _this.structure,
            breakdowns: _this.breakdowns,
            frequencies: _this.frequencies,
            organization: _this.organization,
            table: _this.table,
            sql: _this.sql,
            label: _this.label,
            columns: _this.columns,
            columnType: _this.columnType
        }); };
        this.id = id;
        this.type = type;
        this.name = name;
        this.header = header;
        this.structure = structure;
        this.breakdowns = breakdowns;
        this.frequencies = frequencies;
        this.organization = organization;
        this.table = table;
        this.sql = sql;
        this.label = label;
        this.columns = columns;
        this.columnType = columnType;
    }
    Chart.fromJSON = function (json) {
        var _a = Object.assign({}, json), id = _a.id, type = _a.type, name = _a.name, header = _a.header, structure = _a.structure, breakdowns = _a.breakdowns, frequencies = _a.frequencies, organization = _a.organization, table = _a.table, sql = _a.sql, label = _a.label, columns = _a.columns, columnType = _a.columnType;
        if (typeof id !== 'string')
            throw new Error('.id must be a string');
        if (!type)
            throw new Error('Chart.type missing');
        if (typeof type !== 'string')
            throw new Error('.type must be a string');
        if (typeof name !== 'string' && name !== undefined)
            throw new Error('.name must be a string');
        if (typeof sql !== 'string' && sql !== undefined)
            throw new Error('.sql must be a string');
        if (!Array.isArray(frequencies) && frequencies !== undefined)
            throw new Error('.frequencies must be an array');
        if (type !== 'BAR' &&
            type !== 'TABLE' &&
            type !== 'SINGLE_VALUE' &&
            type !== 'LINE' &&
            type !== 'COMBINATION' &&
            type !== undefined)
            throw new Error('.type must be a ChartType');
        var _organization = organization ? Organization_1["default"].fromJSON(organization) : undefined;
        var _header = header ? ChartHeader_1["default"].fromJSON(header) : undefined;
        var _table = table ? ChartDataTable_1["default"].fromJSON(table) : undefined;
        var _structure = structure ? ChartDataStructure_1["default"].fromJSON(structure) : undefined;
        if (_structure === undefined) {
            throw new Error('.structure must be a ChartDataStructure');
        }
        var _breakdowns = breakdowns ? breakdowns.map(function (item) { return ChartBreakdown_1["default"].fromJSON(item); }) : null;
        if (columnType !== 'DATE' && columnType !== 'TIME_RANGE' && columnType !== undefined)
            throw new Error('.type must be a ColumnType');
        // deprecation
        if (label && typeof label !== 'string')
            throw new Error('.label must be a string');
        if (columns && !Array.isArray(columns))
            throw new Error('.columns must be an array');
        return new Chart({
            id: id,
            type: type,
            name: name,
            header: _header,
            structure: _structure,
            breakdowns: _breakdowns,
            frequencies: frequencies,
            organization: _organization,
            table: _table,
            sql: sql,
            label: label,
            columns: columns,
            columnType: columnType
        });
    };
    return Chart;
}());
exports["default"] = Chart;
